import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import { makeStyles, Theme } from '@material-ui/core'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import ToggleSwitch from 'components/ToggleSwitch/ToggleSwitch'
import React from 'react'

const useShowHideToggleButtonStyles = makeStyles((theme: Theme) => ({
    toggleLabel: {
        fontSize: pxToRem(14),
    },
    switchWorkspaceToggle: {
        fontFamily: 'Roboto',
        fontWeight: 500,
        fontSize: pxToRem(13),
        lineHeight: '100%',
        letterSpacing: '0%',
        color: '#314959',
    },
    workspaceControl: {
        marginBottom: 0,
    },
}))

export interface ShowHideToggleButton {
    label?: string
    checked?: boolean
    onChange?: VoidFunction
    labelPlacement?: 'top' | 'start' | 'bottom' | 'end'
    isWorkspaceToggle?: boolean
}

const ShowHideToggleButton: React.FC<ShowHideToggleButton> = ({
    label,
    checked = false,
    onChange,
    labelPlacement = 'end',
    isWorkspaceToggle = false,
}) => {
    const classes = useShowHideToggleButtonStyles()

    return (
        <FormControlLabel
            control={
                <ToggleSwitch
                    checked={checked}
                    onChange={onChange}
                    isWorkspaceToggle={isWorkspaceToggle}
                />
            }
            classes={{
                label: isWorkspaceToggle
                    ? classes.switchWorkspaceToggle
                    : classes.toggleLabel,
                root: isWorkspaceToggle ? classes.workspaceControl : '',
            }}
            labelPlacement={labelPlacement}
            label={label}
            data-testid={`${label}Toggle`}
        />
    )
}

export default ShowHideToggleButton
